module.exports = '<svg width="53" height="32" viewBox="0 0 53 32"><path d="M.795 23.803a2.488 2.488 0 0 0 0 3.648l3.824 3.643c1.051 1.008 2.763 1.008 3.813 0l18.16-17.573 18.315 17.717c1.056 1.008 2.768 1.008 3.819 0l3.824-3.648a2.504 2.504 0 0 0 0-3.648L28.507.742c-1.056-1.003-2.768-1.003-3.824 0L.795 23.803z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-2.js
// module id = 1468
// module chunks = 14